<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <div>

      <b-modal
          id="modal-excel"
          centered
          ok-only
          ok-title="دریافت"
          title="دریافت اکسل سفارشات"
          @ok="downloadFile"
      >
        <b-form-group
            label="وضعیت پرداخت‌ها :"
            label-for="name-input"
        >
          <label>وضعیت پرداخت‌ها :</label>
          <v-select
              v-model="excelIsPayed"
              :clearable="false"
              :options="perStatusOptions"
              :reduce="val => val.value"
              class="per-page-selector d-inline-block w-75 mx-50"
          />
        </b-form-group>
        <b-form-group>
          <label>شروع تاریخ از :</label>
          <input
              id="excelFrom"
              :value="createJalaliDate(excelFrom)"
              class="form-control p-0 form-control-lg mx-auto block w-full rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
              type="text"
          />
          <custom-date-picker
              v-model="excelFrom"
              auto-submit
              class="position-absolute p-0"
              color="#5c6bc0"
              display-format="jYYYY/jMM/jDD"
              element="excelFrom"
              format="YYYY-MM-DD"
              simple
              type="date"
          ></custom-date-picker>
        </b-form-group>
        <b-form-group>
          <label>تا تاریخ :</label>
          <input
              id="excelTo"
              :value="createJalaliDate(excelTo)"
              class="form-control p-0 form-control-lg mx-auto block w-full rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
              type="text"
          />
          <custom-date-picker
              v-model="excelTo"
              auto-submit
              class="position-absolute p-0"
              color="#5c6bc0"
              display-format="jYYYY/jMM/jDD"
              element="excelTo"
              format="YYYY-MM-DD"
              simple
              type="date"
          ></custom-date-picker>
        </b-form-group>
      </b-modal>

      <!-- Table Container Card -->
      <b-card
          class="mb-0"
          no-body
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <b-col
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                cols="12"
                md="3"
            >
              <label>نوع سفارش</label>
              <v-select
                  v-model="searchPurchasedByAdmin"
                  :clearable="false"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="searchPurchasedByAdminOptions"
                  :reduce="val => val.value"
                  class="per-page-selector d-inline-block mx-50 w-50"
              />
              <label>تعداد</label>
            </b-col>
            <b-col
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                cols="12"
                md="2"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perPage"
                  :clearable="false"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>تعداد</label>
            </b-col>
            <b-col
                cols="12"
                md="3"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="filterPrice"
                    class="d-inline-block mr-1"
                    placeholder="جستجو بر اساس قیمت نهایی..."
                    type="number"
                />
              </div>
            </b-col>
            <!-- Search -->
            <b-col
                cols="12"
                md="4"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="debouncedSearch"
                    class="d-inline-block mr-1"
                    placeholder="جستجو..."
                />
              </div>
            </b-col>
            <b-col
                class="d-flex align-items-center justify-content-start mt-1"
                cols="12"
                md="3"
            >
              <label class="mr-1">شروع تاریخ از : </label>
              <input
                  id="startPaymentDate"
                  :value="createJalaliDate(startPaymentDate)"
                  class="form-control p-0 form-control-lg mx-auto block w-50 rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                  type="text"
              />
              <custom-date-picker
                  v-model="startPaymentDate"
                  class="position-absolute p-0"
                  color="#5c6bc0"
                  display-format="jYYYY/jMM/jDD"
                  element="startPaymentDate"
                  format="YYYY-MM-DD"
                  simple
                  type="date"
              ></custom-date-picker>
            </b-col>
            <b-col
                class="d-flex align-items-center justify-content-start mt-1"
                cols="12"
                md="3"
            >
              <label class="mr-1">تا : </label>
              <input
                  id="endPaymentDate"
                  :value="createJalaliDate(endPaymentDate)"
                  class="form-control p-0 form-control-lg mx-auto block w-50 rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                  type="text"
              />
              <custom-date-picker
                  v-model="endPaymentDate"
                  class="position-absolute p-0"
                  color="#5c6bc0"
                  display-format="jYYYY/jMM/jDD"
                  element="endPaymentDate"
                  format="YYYY-MM-DD"
                  simple
                  type="date"
              ></custom-date-picker>
            </b-col>
            <b-col
                class="d-flex align-items-center justify-content-start mt-1"
                cols="12"
                md="2"
            >
              <b-button
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  variant="warning"
                  @click="getOrders"
              >
                جستجو با تاریخ
              </b-button>
            </b-col>
            <b-col
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0 mt-1"
                cols="12"
                md="3"
            >
              <label>سفارش برای دیگری</label>
              <v-select
                  v-model="forOther"
                  :clearable="false"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="forOtherOption"
                  :reduce="val => val.value"
                  class="per-page-selector d-inline-block mx-50 w-50"
              />
            </b-col>
            <b-col
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0 mt-1"
                cols="12"
                md="3"
            >
              <label class="mb-0">استفاده شده از کیف پول</label>
              <b-form-checkbox
                  v-model="walletUsed"
                  class="ml-1"
                  name="check-button"
                  switch
                  inline
              >
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                cols="12"
                md="2"
            >
              <span>تعداد سفارشات درگاه : </span>
              <span class="mx-1">{{ notPurchasedByAdmin }}</span>
            </b-col>
            <b-col
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                cols="12"
                md="8"
            >
              <span>تعداد سفارشات دیگر (کارت به کارت (ادمین) - رایگان - کارت به کارت (کاربر) - اشتباهات درگاه (ادمین) : </span>
              <span class="mx-1">{{ purchasedByAdmin }}</span>
            </b-col>

            <b-col
                class="d-flex align-items-center justify-content-start mt-1"
                cols="12"
                md="2"
            >
              <b-button
                  v-b-modal.modal-excel
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  class=""
                  variant="success"
              >
                دانلود اکسل لیست
              </b-button>
            </b-col>
          </b-row>
        </div>

        <b-table
            ref="refUserListTable"
            :fields="myTableColumns"
            :items="orders"
            bordered
            class="position-relative"
            empty-text="موردی موجود نیست!"
            primary-key="id"
            responsive
            show-empty
            striped
        >

          <!-- Column: Status -->
          <template #cell(isPayed)="data">
            <b-badge
                v-if="data.item.isPayed"
                :variant="`success`"
                class="text-capitalize"
                pill
            >
              پرداخت شده
            </b-badge>
            <b-badge
                v-else
                :variant="`danger`"
                class="text-capitalize"
                pill
            >
              پرداخت نشده
            </b-badge>
          </template>

          <!-- Column: userInfo -->
          <template #cell(userInfo)="data">
            <span v-if="data.item.userInfo !== null">{{ data.item.userInfo.name }}  {{
                data.item.userInfo.familyName
              }}</span>
          </template>

          <!-- Column: sumPrice -->
          <template #cell(sumPrice)="data">
            <span>
               {{ makePrettyPrice(data.item.sumPrice) }} تومان
            </span>
          </template>

          <!-- Column: sumPrice -->
          <template #cell(finalPrice)="data">
            <span v-if="data.item.sumPriceAfterDiscount">
               {{ makePrettyPrice(data.item.sumPriceAfterDiscount) }} تومان
            </span>
            <span v-else>
              {{ makePrettyPrice(data.item.sumPrice) }} تومان
            </span>
          </template>

          <!-- Column: sumPrice -->
          <template #cell(discount)="data">
            <span v-if="data.item.sumPriceAfterDiscount">
               {{ makePrettyPrice(data.item.sumPrice - data.item.sumPriceAfterDiscount) }} تومان
            </span>
            <span v-else>-</span>
          </template>

          <!-- Column: createDate -->
          <template #cell(createDate)="data">
            <span>
              {{ data.item.createDate.slice(11, 16) }}
              -
              {{ createJalaliDate(data.item.createDate.slice(0, 10)) }}
            </span>
          </template>

          <!-- Column: subOrders -->
          <template #cell(subOrders)="data">
            <span v-if="data.item.subOrders[0].productInfo">(محصول) {{
                data.item.subOrders[0].productInfo.title
              }} </span>
            <span v-else-if="data.item.subOrders[0].seminarInfo">(سمینار) {{
                data.item.subOrders[0].seminarInfo.title
              }}</span>
          </template>

          <!-- Column: Status -->
          <template #cell(status)="data">
            <span v-if="data.item.status === 1">ثبت شده</span>
            <span v-else-if="data.item.status === 2">پرداخت شده</span>
            <span v-else-if="data.item.status === 3">ارسال شده</span>
            <span v-else-if="data.item.status === 4">تحویل داده شده</span>
            <span v-else-if="data.item.status === 5" class="text-danger">رد شده</span>

            <b-dropdown
                no-caret
                variant="link"
            >
              <template #button-content>
                <feather-icon
                    class="align-middle text-body"
                    icon="ChevronDownIcon"
                    size="16"
                />
              </template>

              <b-dropdown-item @click="changeOrderStatus(data.item.orderId,1)">
                <span class="align-middle ml-50">ثبت شده</span>
              </b-dropdown-item>

              <b-dropdown-item @click="changeOrderStatus(data.item.orderId,2)">
                <span class="align-middle ml-50">پرداخت شده</span>
              </b-dropdown-item>

              <b-dropdown-item @click="changeOrderStatus(data.item.orderId,3)">
                <span class="align-middle ml-50">ارسال شده</span>
              </b-dropdown-item>

              <b-dropdown-item @click="changeOrderStatus(data.item.orderId,4)">
                <span class="align-middle ml-50">تحویل داده شده</span>
              </b-dropdown-item>

              <b-dropdown-item @click="changeOrderStatus(data.item.orderId,5)">
                <span class="align-middle ml-50">رد شده</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
          <template #cell(isForOtherUser)="data">
            <span v-b-tooltip.hover.top="'مشاهده جزئیات در نمایش سفارش'" v-if="data.item.isForOtherUser"
                  class="align-middle">فردی دیگر</span>
            <span v-b-tooltip.hover.top="'مشاهده جزئیات در نمایش سفارش'" v-else class="align-middle">خودِ فرد</span>
          </template>

          <template #cell(manualRecieptType)="data">
            <span v-if="data.item.sumPrice === data.item.usedWalletPrice">کیف پول</span>
            <span v-else-if="data.item.manualRecieptType === 0">درگاه</span>
            <span v-else-if="data.item.manualRecieptType === 1">رایگان</span>
            <span v-else-if="data.item.manualRecieptType === 2">اشتباهات درگاه (ادمین)</span>
            <span v-else-if="data.item.manualRecieptType === 3">کارت به کارت (ادمین)</span>
            <span v-else-if="data.item.manualRecieptType === 4">کارت به کارت (کاربر)</span>
          </template>

          <!-- Column: Actions -->
          <template #cell(delete)="data">
            <b-link v-b-modal.modal-delete @click="showModal(data.item.orderId)">
              <feather-icon class="text-danger" icon="TrashIcon" size="20"/>
            </b-link>
          </template>
          <template #cell(edit)="data">
            <b-link :to="{ name: 'apps-orders-info', params: { id: data.item.orderId } }">
              <feather-icon icon="EditIcon" size="20"/>
            </b-link>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
                cols="12"
                sm="6"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
                cols="12"
                sm="6"
            >
              <QueriedPagination v-if="totalCounts" v-model="currentPage" :total-counts="totalCounts"
                                 :per-page="perPage"></QueriedPagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
    <b-modal
        id="modal-delete"
        cancelTitle="انصراف"
        centered
        ok-title="حذف"
        @ok="deleteOrder(deleteItem)"
    >
      <span>حذف شود؟</span>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem, BFormCheckbox, BFormGroup,
  BFormInput,
  BLink,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BTable,
  VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {OrderChangeStatusRequest, OrderDeleteRequest, OrderGetAllRequest} from "@/libs/Api/Order";
import Helper from "@/libs/Helper";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {getUserData} from "@/auth/utils";
import axiosIns from "@/libs/axios";
import {saveAs} from 'file-saver';
import QueriedPagination from "@/views/components/QueriedPagination.vue";

export default {
  name: "OrdersList",
  title: "لیست سفارشات - پنل ادمین ذهن آرایی",
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      orders: [],
      deleteItem: null,
      currentPage: 1,
      totalCounts: null,
      perPage: 10,
      overlay: false,
      purchasedByAdmin: 0,
      startPaymentDate: '',
      endPaymentDate: '',
      notPurchasedByAdmin: null,
      searchPurchasedByAdmin: null,
      timeOut: null,
      filterPrice: '',
      forOther: null,
      walletUsed: null,
      perStatusOptions: [
        {label: 'همه', value: ''},
        {label: 'پرداخت موفق', value: true},
        {label: 'پرداخت ناموفق', value: false},
      ],
      forOtherOption: [
        {label: 'همه', value: null},
        {label: 'برای دیگری', value: true},
        {label: 'برای خود فرد', value: false},
      ],
      walletOption: [
        {label: 'همه', value: null},
        {label: 'بله', value: true},
        {label: 'خیر', value: false},
      ],
      searchPurchasedByAdminOptions: [
        {label: 'همه', value: null},
        {label: 'درگاه', value: 0},
        {label: 'رایگان', value: 1},
        {label: 'اشتباهات درگاه (ادمین)', value: 2},
        {label: 'کارت به کارت (ادمین)', value: 3},
        {label: 'کارت به کارت (کاربر)', value: 4},
      ],
      perPageOptions: [10, 20, 30, 40, 50],
      myTableColumns: [
        {key: 'orderId', label: 'شناسه سفارش'},
        {key: 'userInfo', label: 'اطلاعات کاربر'},
        {key: 'userInfo.mobile', label: 'موبایل کاربر'},
        {key: 'subOrders', label: 'عنوان سفارش'},
        {key: 'isPayed', label: 'وضعیت پرداخت'},
        {key: 'sumPrice', label: 'مبلغ سفارش'},
        {key: 'usedWalletPrice', label: 'کسر از کیف پول'},
        {key: 'discount', label: 'مبلغ تخفیف'},
        {key: 'finalPrice', label: 'قیمت نهایی'},
        {key: 'createDate', label: 'تاریخ ثبت'},
        {key: 'status', label: 'وضعیت'},
        {key: 'isForOtherUser', label: 'خریدار'},
        {key: 'manualRecieptType', label: 'نوع سفارش'},
        {key: 'delete', label: 'حذف سفارش'},
        {key: 'edit', label: 'نمایش سفارش'},
      ],
      searchQuery: '',
      isAddNewUserSidebarActive: false,
      excelIsPayed: '',
      excelFrom: '',
      excelTo: '',
    }
  },
  async created() {
    if (this.$route.query.pageNumber) {
      this.currentPage = +this.$route.query.pageNumber
    }
    await this.getOrders()
  },
  methods: {
    async getOrders() {
      // Store reference to component instance
      const _this = this;
      // Show loading overlay
      _this.overlay = true;

      // Build request parameters object
      const data = {
        pageNumber: _this.currentPage,
        count: _this.perPage,
        searchCommand: _this.searchQuery,
        filterPrice: _this.filterPrice,
        startDate: _this.startPaymentDate,
        endDate: _this.endPaymentDate,
        type: _this.searchPurchasedByAdmin ?? '',
        forOther: _this.forOther ?? '',
        IsUsedWallet: _this.walletUsed ? _this.walletUsed : "",

      }

      // Create new order request instance
      const orderGetAllRequest = new OrderGetAllRequest(_this);
      // Set request parameters
      orderGetAllRequest.setParams(data);

      try {
        // Make API request to fetch orders
        const content = await orderGetAllRequest.fetch(
            content => {
              // Update component data with response
              _this.orders = content.orders;
              _this.totalCounts = content.ordersCount;
              _this.notPurchasedByAdmin = content.notPurchasedByAdmin;
              _this.purchasedByAdmin = content.purchasedByAdmin;
            },
            error => {
              // Log any errors
              console.log(error);
            }
        );
      } catch (error) {
        // Log any caught errors
        console.log(error);
      } finally {
        // Hide loading overlay when done
        _this.overlay = false;
      }
    },
    async deleteOrder(param) {
      let _this = this;
      _this.overlay = true;

      let orderDeleteRequest = new OrderDeleteRequest(_this);
      orderDeleteRequest.setId(param);
      await orderDeleteRequest.fetch(function (content) {
        _this.overlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `سفارش حذف شد.`,
          },
        })
        _this.getOrders()
      }, function (error) {
        _this.overlay = false;
        console.log(error)
      })
    },
    async changeOrderStatus(orderId, status) {
      let _this = this;
      _this.overlay = true;
      let data = {
        orderId: orderId,
        status: status,
      }

      let orderChangeStatusRequest = new OrderChangeStatusRequest(_this);
      orderChangeStatusRequest.setId(data);
      await orderChangeStatusRequest.fetch(function (content) {
        _this.overlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `تغییرات اعمال شد.`,
          },
        })
        _this.getOrders()
      }, function (error) {
        _this.overlay = false;
        console.log(error)
      })
    },
    makePrettyPrice(param) {
      return Helper.prettyPrice(param, 0)
    },
    createJalaliDate(param) {
      if (param !== null && param !== '') {
        return new Date(param).toLocaleDateString("fa-IR",);
      }
    },
    showModal(param) {
      let _this = this;
      _this.deleteItem = param
    },
    async downloadFile() {
      let _this = this;
      if (_this.excelFrom === '' || _this.excelTo === '') {
        return _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CheckIcon',
            variant: 'danger',
            text: `تمامی فیلد‌ها الزامی میباشند.`,
          },
        })
      }
      this.$store.commit('app/TOGGLE_DOWNLOAD')
      let userToken = getUserData().token;

      await axiosIns.post(`Order/GetExcel`, null, {
        params: {
          isPayed: this.excelIsPayed,
          from: this.excelFrom,
          to: this.excelTo
        },
        responseType: 'blob',
      }).then(resp => {
        _this.overlay = false;
        saveAs(resp.data, 'لیست.xlsx');
      }).catch((error) => {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: 'عملیات ناموق!',
            icon: 'CheckIcon',
            variant: 'danger',
            text: 'به علت ترافیک بالا سرور لطفا 30 دقیقه دیگر امتحان کنید',
          },
        })
      }).finally(() => {
        this.$store.commit('app/TOGGLE_DOWNLOAD')
      });
    },
  },
  watch: {
    perPage: function (nv, ov) {
      this.getOrders();
    },
    getQuery: function (nv, ov) {
      this.getOrders();
    },
    searchQuery: function (nv, ov) {
      this.getOrders()
    },
    searchPurchasedByAdmin(nv, ov) {
      this.getOrders()
    },
    forOther(nv, ov) {
      this.getOrders()
    },
    filterPrice(nv, ov) {
      this.getOrders()
    },
    walletUsed(nv, ov) {
      this.getOrders()
    }
  },
  computed: {
    getQuery() {
      return this.$route.query
    },
    debouncedSearch: {
      get() {
        return this.searchQuery
      },
      set(val) {
        if (this.timeOut) {
          clearTimeout(this.timeOut)
        }
        this.timeOut = setTimeout(() => {
          this.searchQuery = val
        }, 600)
      }
    }
  },
  components: {
    BFormCheckbox, BFormGroup,
    QueriedPagination,
    BButton,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,
    vSelect,
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
